import React, { useEffect, useState } from 'react';
import "./OnlineForm.css";
import { Button } from 'grommet';
import { useStore } from '../../../../../Hooks/useStore';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import FormSubmit from '../../../../../services/form/formSubmit';

const ViewDetailedForm = () => {  
    const params = useParams(); 
    const navigate = useNavigate();
    const location = useLocation();
    const { rootStore } = useStore() 
    const formId = params.formId;
    const [phoneNumberArray, setPhoneNumberArray] = useState([
        {id: 1, value: ""}
    ]);
    const [emailArray, setEmailArray] = useState([
        {id: 1, value: ""}
    ]);
    const [crewMemArr1, setCrewMemArr1] = useState([
        {id: 1, firstname: "", lastName: "", genderIdentity: "", email: ""}
    ]);
    const [airInfoArr1, setAirInfoArr] = useState([
        {id: 1, Reg: "", msn: "", fleetType: "", wifiPro: ""}
    ]);

    
    const [leagalEntityName,setLegalEntityName] = useState("");
    const [address,setAddress] = useState("");
    const [ userInfo, setUserInfo] = useState("");
    const [isVerified, setIsVerified] = useState(true)

    

    const fetchFormData = async (id) => {
        try {
            rootStore.loadingStore.setShowLoader(true);
            const formData = await FormSubmit.getFormDataById(id);
            setLegalEntityName(formData?.data?.organizationTemp?.name);
            setAddress(formData?.data?.organizationTemp?.address);
            setUserInfo(formData?.data?.createdBy);
            setPhoneNumberArray(formData?.data?.organizationTemp?.phoneNumbers)
            setEmailArray(formData?.data?.organizationTemp?.emails)
            setCrewMemArr1(formData?.data?.crewTemps);
            setAirInfoArr(formData?.data?.flightTemps);
            setIsVerified(formData?.data?.isVerified);
            rootStore.loadingStore.setShowLoader(false);
          } catch (error) {
            console.error("Error fetching forms:", error);
          }
    }

    useEffect(() => {
        let user = JSON.parse(localStorage.getItem("userinfo"));
        setTimeout(() => {
          if (user && user.roleLabel.toLowerCase() === "superadmin") {
            fetchFormData(formId);
          } else {
            const from = location.pathname;
            localStorage.setItem("redirectRoute", from);
            navigate('/');
          }
        }, 200);
      }, []);
      
      

    const formApprove = async () => {
        try{
            rootStore.loadingStore.setShowLoader(true)
            await FormSubmit.approveSelectedForm(formId);
            rootStore.notificationToastStore.showNotification(
                "Form Approved successfully",
                false,
                3000
            );
            rootStore.loadingStore.setShowLoader(false)
            setIsVerified(true)
        } catch(err){
            rootStore.notificationToastStore.showNotification(
                "Failed to approve form. Please try again later.",
                true,
                3000
              );
            rootStore.loadingStore.setShowLoader(false);
        }
        
    }

    return (
        <div className='form-container'>
            <h2 className='heading'>Appendix A</h2>
            <h2 className='heading'>SERVICE START NOTIFICATION</h2>
            <p className='form-description'>
                This is to notify you of the commencement of services by Skali Inc. The details of the organization have been filled out in this form. 
                Please note that all information provided in this form is deemed confidential and will not be disclosed externally without the approved 
                written consent of the sending organization.
            </p>
            <h3 className='sub-heading'>ORGANIZATION INFORMATION</h3>
            <table className='form-table first'>
                <tbody>
                    <tr>
                        <th>LEGAL ENTITY NAME</th>
                        <td><input placeholder='type here' type='text' value={leagalEntityName}  disabled /></td>
                    </tr>
                    <tr>
                        <th>ADRESS</th>
                        <td><input placeholder='type here' type='text' value={address}  disabled /></td>
                    </tr>
                    <tr>
                        <th>PHONE NUMBER</th>
                        <td>
                            {
                                phoneNumberArray.map((item, index) => {
                                    return (
                                        <div key={item.id}>
                                            <div className='input-main'>
                                                <input  value={item} placeholder='type here' type='text' disabled />
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </td>
                    </tr>
                    <tr>
                        <th>EMAIL</th>
                        <td>
                        {
                                emailArray.map((item, index) => {
                                    return (
                                        <div key={item.id}>
                                            <div className='input-main'>
                                                <input placeholder='type here' value={item} type='text' disabled />
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
            <h3 className='sub-heading bold-heading'>CREW INFORMATION</h3>
            <p className='sub-heading-description'>
                This is to notify you of the commencement of services by Skali Inc. The details of the organization have been filled out in this form. 
                Please note that all information provided in this form is deemed confidential and will not be disclosed externally without the approved 
                written consent of the sending organization.
            </p>
            <table className='form-table second'>
                <thead>
                    <tr>
                        <th style={{textAlign: "center"}} colSpan={4}>FLIGHT CREW MEMBER</th>
                    </tr>
                    <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Gender Identity</th>
                        <th>Email</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        crewMemArr1.map((item, index) => {
                            return (
                                <tr key={item.id}>
                                    <td><input  value={item?.name} type='text' disabled /></td>
                                    <td><input  value={item?.familyName} type='text' disabled /></td>
                                    <td><input  value={item?.gender} type='text' disabled /></td>
                                    <td><input  value={item?.email} type='text' disabled />

                                    </td>
                                </tr>
                            )
                        })

                    }

                </tbody>
            </table>

            <h3 className='sub-heading bold-heading'>AIRCRAFT INFORMATION</h3>
            <p className='sub-heading-description'>
                Please provide the following information for all aircraft which you intend to operate Skali equipped EFBs and Skali, Inc provided medical kits.
                 Also please provide any typical route data commonly flown by your organization. This information is considered confidential and will not be shared
                  externally without the expressed written consent of your organization.
            </p>
            <table className='form-table second'>
                <thead>
                    <tr>
                        <th style={{textAlign: "center"}} colSpan={4}>AIRCRAFT INFORMATION</th>
                    </tr>
                    <tr>
                        <th>Registration (Ex. N12345)</th>
                        <th>MSN</th>
                        <th>Fleet Type (Ex. 737-400)</th>
                        <th>Wi-Fi Provider (Ex. Gogo)</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        airInfoArr1.map((item, index) => {
                            return (
                                <tr key={item.id}>
                                    <td><input  value={item?.id} type='text' disabled /></td>
                                    <td><input  value={item?.msn} type='text' disabled /></td>
                                    <td><input  value={item?.fleetType} type='text' disabled /></td>
                                    <td><input  value={item?.wifiProvider} type='text' disabled />
                                    </td>
                                </tr>
                            )
                        })

                    }

                </tbody>
            </table>

            <div>
                <h3 className='sub-heading bold-heading'>USER INFORMATION</h3>
                <div className='user-name-section'>
                    <label>Enter Your Name: </label>
                    <input type='text' value={userInfo}  disabled />
                </div>
            </div>
            {
                !isVerified && 
                <div>
                <Button
                style={{
                    backgroundColor: "rgb(53, 126, 255)",
                    border: "1px solid rgb(53, 126, 255)",
                    radius: "10px",
                    padding: "12px 28px",
                    color: "#FFF",
                    lineHeight: "16px",
                    marginLeft: "91%",
                    borderRadius: "10px"
                }}
                onClick={() => formApprove()}
                disabled = {leagalEntityName === "" || address === "" || phoneNumberArray[0].value === "" || emailArray[0].value === "" || userInfo === ""}
                >
                    Approve
                </Button>
            </div>
            }
            
        </div>
    );
}

export default ViewDetailedForm;
